import { render, staticRenderFns } from "./MessageManager.vue?vue&type=template&id=75cba13a&lang=pug&"
import script from "./MessageManager.ts?vue&type=script&lang=js&"
export * from "./MessageManager.ts?vue&type=script&lang=js&"
import style0 from "./MessageManager.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports